import React, { useState } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { Tooltip } from '@material-ui/core';
import { LaunchRounded, CloseRounded } from '@material-ui/icons';
import styles from './styles';
import LoadingV2 from '@/components/Loading';
import clsx from 'clsx';

// const apiKey = 'AIzaSyCFM3CuJxSHXOUZQ79c2axVTPlO1vsL3-4';
const apiKey = 'AIzaSyCpZf-tnhdvT1n8MR7eF7UK8DFcDn_6zsY';
const showCurrentPopup = false;

const MapContainer = ({
  className,
  google,
  DATA = [],
  smart,
  onMarkerClick,
}) => {
  const cls = styles();

  const [popUp, setPopUp] = useState(true);
  const [state, setState] = useState({
    loading: true,
    Markers: [],
    Center: {
      lat: 40.854885,
      lng: -88.081807,
    },
  });

  React.useEffect(() => {
    if (DATA.length) {
      // Filter out items without valid coordinates
      const validMarkers = DATA.filter(
        (item) =>
          (item.pos &&
            item.pos.lat &&
            item.pos.lng &&
            !isNaN(parseFloat(item.pos.lat)) &&
            !isNaN(parseFloat(item.pos.lng))) ||
          (item.address &&
            item.address.lat &&
            item.address.long &&
            !isNaN(parseFloat(item.address.lat)) &&
            !isNaN(parseFloat(item.address.long)))
      );

      if (validMarkers.length > 0) {
        setState({
          Markers: validMarkers,
          Center: validMarkers[0].pos
            ? validMarkers[0].pos
            : {
                lat: validMarkers[0].address.lat,
                lng: validMarkers[0].address.long,
              },
          loading: false,
        });
      } else {
        setState((s) => ({ ...s, Markers: [], loading: false }));
      }
    } else {
      setState((s) => ({ ...s, loading: false }));
    }
  }, [DATA]);

  const toggle = () => setPopUp(!popUp);

  if (state.loading) return <LoadingV2 />;

  return (
    <Map
      center={state.Center}
      google={google}
      className={clsx(className ? cls.smallContainer : cls.container)}
      zoom={10}
      containerStyle={{
        height: className?.includes('h-244')
          ? '214px'
          : className?.includes('h-264')
          ? '264px'
          : undefined,
        position: 'relative',
      }}
      disableDefaultUI
      gestureHandling="cooperative"
      initialCenter={state.Center}>
      {state.Markers.map((item, index) => (
        <Marker
          title={item.name || item.cabin.company.name}
          position={
            item.pos || {
              lat: item.address.lat,
              lng: item.address.long,
            }
          }
          key={index}
          onClick={() => onMarkerClick && onMarkerClick(item, index)}
        />
      ))}

      {showCurrentPopup && (
        <div className={cls.popUpCont}>
          {popUp ? (
            <div className={cls.popUp}>
              <CloseRounded className={cls.close} onClick={toggle} />
              <div className={cls.cont}>
                <h1>Why smart search is better?</h1>
                <h2>
                  Smart search improve your search and make sure you
                  won't miss your target, check every offered container
                  and fulfill your need.
                </h2>
              </div>

              <div onClick={smart} className={cls.but}>
                smart search
              </div>
            </div>
          ) : (
            <div className={cls.mini} onClick={toggle}>
              <Tooltip title="Smart search" placement="top" arrow>
                <LaunchRounded className={cls.launch} />
              </Tooltip>
            </div>
          )}
        </div>
      )}
    </Map>
  );
};

export default GoogleApiWrapper({ apiKey })(MapContainer);
